import React from 'react'


export default function Footer() {
  return (
    <footer>
       <div>
        <h2>Technical Cube</h2>
        <p>@all right reserved</p>
       </div>
       <div>
        <h4>
           Follow Us 
        </h4>
        <div>
            <a href="https://www.youtube.com/" target={'blank'}>Youtube</a>
            <a href="https://www.twitter.com/" target={'blank'}>Twitter</a>
            <a href="https://www.instagram.com/" target={'blank'}>Instagram</a>
            <a href="https://www.facebook.com/" target={'blank'}>Facebook</a>
        </div>
       </div>
    </footer>
  )
}
